export const minActualPrice = (hit) => {
  if (hit.aa_pricing_info.offers.length > 0) {
    return hit.aa_pricing_info.offers.reduce((res, obj) => {
      return obj.actual < res.actual ? obj : res
    })
  } else {
    return null
  }
}
